module.exports = __webpack_public_path__ + "media/images/puddin_magzine_img-51cafa66b3e877648928fb5a6a05e559.svg";